import React, { useCallback } from 'react';
import type { CampaignLaunchAnswers } from 'fym-shared/src/music24/campaignLaunch';
import { TypedMemo } from '../../../../../../common/types';
import { useRollout } from '../RolloutContext';
import { PostsLaunchQuestions } from './PostsLaunchQuestions';

/** The launch questions of the rollout run sheet (`PostsLaunchQuestions`, fed by the rollout actions). */
const LaunchQuestionsDialogComponent: React.FC = () => {
  const { accountId, actions } = useRollout();
  const pending = actions.pendingLaunch;
  const feedback = pending === null ? null : (actions.feedback[pending.place] ?? null);
  const { answerLaunch } = actions;
  const answer = useCallback(
    (answers: CampaignLaunchAnswers) => {
      answerLaunch(answers).catch(console.error);
    },
    [answerLaunch]
  );
  return (
    <PostsLaunchQuestions
      accountId={accountId}
      pending={pending}
      isBusy={actions.busy !== null}
      error={feedback?.tone === 'danger' ? feedback.message : undefined}
      onAnswer={answer}
      onCancel={actions.cancelLaunch}
    />
  );
};

export const LaunchQuestionsDialog = TypedMemo(LaunchQuestionsDialogComponent);
